import { render } from "./ProcessingFeePopovers.vue?vue&type=template&id=e4d7311e&scoped=true"
import script from "./ProcessingFeePopovers.vue?vue&type=script&lang=js"
export * from "./ProcessingFeePopovers.vue?vue&type=script&lang=js"

import "./ProcessingFeePopovers.vue?vue&type=style&index=0&id=e4d7311e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d7311e"]])

export default __exports__